import axios from "axios";
import type { IAPI } from "./APIService";
export interface IAuthService {
  forgotPassword: (usernameValue: string) => Promise<IForgotPasswordData>;
}

interface IForgotPasswordData {
  success: boolean;
  error: string;
}
export class AuthService implements IAuthService {
  api: IAPI;

  constructor(api) {
    this.api = api;
  }

  async forgotPassword(usernameValue: string): Promise<IForgotPasswordData> {
    const params = {
      username: usernameValue,
    };

    try {
      await axios.post("/api/dines/forgot_password", params, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return {
        success: true,
        error: null,
      };
    } catch (err) {
      return {
        success: false,
        error: err.response.data.error,
      };
    }
  }
}
